var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatternA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 7.10002V3.31669C18.8333 2.14169 18.3 1.66669 16.975 1.66669H13.6083C12.2833 1.66669 11.75 2.14169 11.75 3.31669V7.09169C11.75 8.27502 12.2833 8.74169 13.6083 8.74169H16.975C18.3 8.75002 18.8333 8.27502 18.8333 7.10002Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 16.475V13.1083C18.8333 11.7833 18.3 11.25 16.975 11.25H13.6083C12.2833 11.25 11.75 11.7833 11.75 13.1083V16.475C11.75 17.8 12.2833 18.3333 13.6083 18.3333H16.975C18.3 18.3333 18.8333 17.8 18.8333 16.475Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25008 7.10002V3.31669C9.25008 2.14169 8.71675 1.66669 7.39175 1.66669H4.02508C2.70008 1.66669 2.16675 2.14169 2.16675 3.31669V7.09169C2.16675 8.27502 2.70008 8.74169 4.02508 8.74169H7.39175C8.71675 8.75002 9.25008 8.27502 9.25008 7.10002Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25008 16.475V13.1083C9.25008 11.7833 8.71675 11.25 7.39175 11.25H4.02508C2.70008 11.25 2.16675 11.7833 2.16675 13.1083V16.475C2.16675 17.8 2.70008 18.3333 4.02508 18.3333H7.39175C8.71675 18.3333 9.25008 17.8 9.25008 16.475Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternA);
export default __webpack_public_path__ + "static/media/pattern-a.ad2fb5c290572206807eb00faf795a05.svg";
export { ForwardRef as ReactComponent };